import { axiosInstance } from './baseApi';

const contractingCompanyApi = {
  getContractingCompanies: (token, accountId) =>
    axiosInstance({
      method: 'get',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/contractingcompany/${accountId}`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
    }),

  combineCompanies: (token, accountId, data) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/contractingcompany/combine-companies`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: { ...data, accountId },
    }),

  deleteCompany: (token, accountId, companyId) =>
    axiosInstance({
      method: 'delete',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/contractingcompany/${accountId}/${companyId}`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
    }),
};

export default contractingCompanyApi; 